import React, { Suspense as ReactSuspense } from 'react';
import { Loading } from 'components/loading/Loading';

interface SuspenseProps {
  element: string;
}

export const Suspense = ({ element }: SuspenseProps) => {
  const LazyComponent = React.lazy(() => import(`./${element}`));

  return (
    <ReactSuspense fallback={<Loading variant="light" />}>
      <LazyComponent />
    </ReactSuspense>
  );
};
